export function normalizeTokenGroupNames(groups: string[] | undefined | null): string[] {
  const source = groups ?? [];
  return source.map((group) => {
    const path = group.startsWith('/') ? group : `/${group}`;
    return path.slice(1);
  });
}
